import { C } from "../../../../constants";
import { daysAgo, fmtMoney } from "../../../../utils";

export default function DealDetailPage({ deal, nav, KpiCardComponent }) {
  const KpiCard = KpiCardComponent;
  if(!deal)return <div style={{padding:32,color:C.sub}}>Not found.</div>;
  const age=daysAgo(deal.stageEnteredDate);
  return (
    <div className="fade det">
      <div className="det-back" onClick={()=>nav("pipeline")}>← Pipeline</div>
      <div className="det-title">{deal.companyName}</div><div className="det-sub">{deal.opportunityName}</div>
      <div className="krow">
        <KpiCard label="Deal Value" value={fmtMoney(deal.dealValue)}/><KpiCard label="Win %" value={`${deal.probability}%`}/><KpiCard label="Close Date" value={deal.expectedCloseDate}/><KpiCard label="Days in Stage" value={`${age}d`} sub={age>14?"⚠ May be stuck":"On track"}/>
      </div>
      <div className="det-grid">
        <div className="icard"><div className="icard-title">Deal Details</div>{[["Stage",deal.stage],["Owner",deal.dealOwner],["Consultant",deal.assignedConsultant||"Unassigned"],["Required Skill",deal.requiredRoleOrSkill],["Next Action",deal.nextAction]].map(([k,v])=><div className="det-row" key={k}><span className="det-key">{k}</span><span className="det-val">{v}</span></div>)}</div>
        <div className="icard"><div className="icard-title">Notes</div><p style={{fontSize:13,color:C.sub,lineHeight:1.75}}>{deal.notes||"No notes."}</p></div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// FORMS
// ─────────────────────────────────────────────────────────────────────────────

